import { CSSProperties, ReactNode } from "react";
import useScreen from "Hooks/useScreen";
import { clsx, styx } from "modules/Utils";

interface FixedButtonContainerProps {
    className?: string;
    style?: CSSProperties;
    children: ReactNode;
}

const FixedButtonContainer = ({ 
    className,
    style,
    children, 
}: FixedButtonContainerProps) => {
    const { mobileView } = useScreen();

    return (
        <div
            className={clsx('primaryButtonContainerComponent', className)}
            style={styx(
                mobileView ? sty.fixedButtonContainerComponent : {},
                style
            )}
        >
            {children}
        </div>
    );
}

const sty: Record<string, CSSProperties> = {
    fixedButtonContainerComponent: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        padding: 16,
        boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white'
    }
}

export default FixedButtonContainer;
